{
  "nav": {
    "home": "Inicio",
    "pick": "Pick",
    "leaderboard": "Clasificación",
    "profile": "Perfil",
    "leagues": "Ligas",
    "active_league": "Liga Activa"
  },
  "common": {
    "error_data": "Error al cargar los datos.",
    "stage": "Etapa",
    "go": "IR",
    "back": "← Atrás",
    "one_day_race": "One Day Race",
    "tomorrow": "Mañana",
    "in_days_one": "Mañana",
    "in_days_many": "En {{count}} días",
    "in_days_other": "En {{count}} días",
    "at_hours": "A las {{hours}}",
    "loading": "Cargando...",
    "confirm": "CONFIRMAR",
    "logout": "SALIR",
    "in_days": "En {{count}} días",
    "error_generic": "Se ha producido un error.",
    "optional": "opcional",
    "tu": "TÚ",
    "error_title": "Error",
    "send": "Enviar",
    "retry": "Reintentar",
    "load_error_title": "No se pueden cargar los datos",
    "load_error_sub": "Comprueba tu conexión e inténtalo de nuevo.",
    "stale_data": "Datos no actualizados: se muestran los guardados."
  },
  "home": {
    "participants": "participantes",
    "section_results": "Últimos resultados",
    "section_upcoming": "Próximas carreras",
    "social": "Síguenos en redes sociales",
    "onboarding_next": "Siguiente →",
    "onboarding_start": "Empezar a jugar →",
    "onboarding_rules": "Leer el reglamento",
    "section_picks": "Picks pendientes",
    "no_races": "No hay carreras para pickear ahora mismo",
    "other_picks_one": "un pick más pendiente →",
    "other_picks_many": "{{count}} picks más pendientes →",
    "other_picks_other": "{{count}} picks más pendientes →",
    "stage_results": "Clasificación",
    "tab_stage": "ETAPA",
    "tab_gc": "GENERAL",
    "no_data": "No hay datos disponibles",
    "onboarding_step1_title": "¡Bienvenido a Virtua Cycling!",
    "onboarding_step1_body": "El fantasy game del ciclismo profesional.",
    "onboarding_step2_title": "Cómo funciona",
    "onboarding_item1": "Elige tus corredores — Antes de cada etapa, elige los corredores en los que apuestas. Tienes tiempo hasta la salida.",
    "onboarding_item2": "Gana puntos — Tus corredores suman puntos según su posición real en la etapa y en la clasificación general.",
    "onboarding_item3": "Crea tu liga — Compite con otros participantes etapa a etapa y escala la clasificación general.",
    "onboarding_step3_title": "¡Estás listo!",
    "onboarding_step3_body": "Estás en la Virtua Cycling League, la liga general donde juegan todos. Lee el reglamento completo para no perderte nada.",
    "kofi_cta": "¿Te gusta la app? ¡Invítanos a una cerveza!",
    "jersey_gc": "Maillot líder GC",
    "jersey_pt": "Maillot de puntos",
    "jersey_gm": "Maillot de montaña",
    "greeting": "Hola, {{name}}",
    "status_ready": "Elecciones confirmadas para la próxima etapa",
    "status_todo": "Aún no has hecho tus elecciones",
    "retry": "Reintentar"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Picks ya enviados — aún puedes cambiarlos",
    "no_pick_stage": "No se encontraron picks para esta etapa.",
    "error_load": "Error al cargar las carreras.",
    "loading": "Cargando...",
    "title": "Pick",
    "no_races_title": "No hay carreras disponibles",
    "no_races_sub": "No hay carreras programadas ahora mismo. ¡Vuelve pronto!",
    "banned_title": "Retirado de la carrera",
    "banned_stages_one": "Te perdiste 1 etapa",
    "banned_stages_many": "Te perdiste {{count}} etapas",
    "banned_stages_other": "Te perdiste {{count}} etapas",
    "banned_detail": "Puedes seguir los resultados y los picks de otros, pero no puedes participar en esta edición.",
    "banned_message": "¡Hasta la próxima!",
    "stage_finished": "Etapa terminada. Aquí están los picks enviados.",
    "live_alert": "Carrera en curso — alineaciones cerradas",
    "startlist_btn": "Lista de salida",
    "startlist_title": "Lista de salida",
    "startlist_search": "Buscar dorsal o nombre",
    "startlist_dnf": "Retirado",
    "startlist_empty": "Lista de salida aún no disponible",
    "tab_insert": "Inserción",
    "tab_summary": "Resumen",
    "start_list_title": "Lista de salida aún no disponible",
    "start_list_sub": "La lista de participantes se publicará en breve. Vuelve más tarde.",
    "need_more_one": "Selecciona {{count}} corredor más.",
    "need_more_many": "Selecciona {{count}} corredores más.",
    "need_more_other": "Selecciona {{count}} corredores más.",
    "error_save": "Error al guardar.",
    "loading_riders": "Cargando corredores...",
    "draft_restored": "Borrador restaurado",
    "draft_count_one": "1 corredor guardado localmente",
    "draft_count_many": "{{count}} corredores guardados localmente",
    "draft_count_other": "{{count}} corredores guardados localmente",
    "draft_cancel": "Cancelar",
    "select_n_one": "Selecciona {{count}} corredor",
    "select_n_many": "Selecciona {{count}} corredores",
    "select_n_other": "Selecciona {{count}} corredores",
    "add_rider": "+ Añadir corredor ({{current}}/{{limit}})",
    "edit_selection": "Editar selección",
    "apply_all": "Aplicar selección a todas mis ligas",
    "saved_for": "Guardado para: {{leagues}}",
    "flip_used": "Flip — usado",
    "flip_available": "Flip — disponible",
    "flip_remove": "Eliminar",
    "flip_abbinato": "{{rider}} asignado al slot {{slot}}",
    "flip_confirmed": "El flip ha sido declarado para esta etapa. Se elegirá el mejor resultado al calcular los puntos.",
    "flip_slot_label": "¿Asignar el flip a qué slot?",
    "flip_confirm_btn": "Confirmar flip",
    "saving": "Guardando...",
    "confirm_pick": "CONFIRMAR PICK {{current}}/{{limit}}",
    "select_riders": "Seleccionar corredores",
    "search_rider": "Buscar corredor...",
    "no_rider_found": "No se encontró ningún corredor",
    "compare_users": "Comparar usuarios",
    "confirm": "Confirmar",
    "no_pick_found": "No se encontraron picks.",
    "toast_multi_one": "Picks guardados en 1 liga",
    "toast_multi_many": "Picks guardados en {{count}} ligas",
    "toast_multi_other": "Picks guardados en {{count}} ligas",
    "toast_single": "¡Picks guardados!",
    "compare_with": "Comparar con {{names}}",
    "compare_default": "Comparar con otros usuarios (max {{max}})",
    "tap_to_change": "• toca para cambiar",
    "you": "(TÚ)",
    "matrix_hint": "Toca un corredor para ver quién lo eligió",
    "user_col": "Usuario",
    "scout_title": "Scouting Report",
    "scout_top_rider": "Corredor más elegido",
    "scout_distribution": "Distribución por slot",
    "scout_variety": "Variedad de la liga",
    "scout_distinct": "Corredores distintos elegidos",
    "scout_identical": "Alineaciones idénticas",
    "scout_no_picks": "Envía tus picks para ver cuántos tienen la misma alineación que tú",
    "loading_lineups": "Cargando alineaciones...",
    "collapse_all": "CONTRAER TODO",
    "expand_all": "EXPANDIR TODO",
    "no_races": "No hay carreras disponibles ahora mismo.",
    "add_rider_one": "+ Añadir corredor ({{current}}/{{limit}})",
    "duplicate_rider": "¡{{name}} ya ha sido usado en una etapa anterior!",
    "draft_count": "Tienes {{count}} corredor(es) guardados localmente",
    "toast_multi": "Picks guardados en {{count}} ligas",
    "scout_chosen_by": "Elegido por: {{names}}",
    "scout_chosen_by_others": "Elegido por: {{names}} y {{count}} más",
    "scout_sharing": "Compartiendo...",
    "scout_share_btn": "Compartir Scouting Report",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Elección más atrevida",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} jugadores",
    "draft_unsaved_banner": "Pick no confirmado — pulsa Confirmar para guardar",
    "draft_unsaved_title": "Pick no confirmado",
    "draft_unsaved_body": "Tienes una selección sin guardar. ¿Quieres confirmar el pick antes de salir?",
    "draft_exit": "Salir sin guardar",
    "draft_confirm_now": "Quedarse y confirmar",
    "share_all": "Todos",
    "current_league": "Liga actual",
    "duplicate_rider_reason": "Ya usado: {{name}}",
    "flip_saved": "¡Flip guardado!",
    "flip_deleted": "Flip eliminado.",
    "flip_add_rider": "+ Añadir corredor flip (opcional)",
    "riders_count_one": "1 corredor",
    "riders_count_many": "{{count}} corredores",
    "riders_count_other": "{{count}} corredores",
    "riders_selected_one": "1 seleccionado",
    "riders_selected_many": "{{count}} seleccionados",
    "riders_selected_other": "{{count}} seleccionados",
    "search_user": "Buscar usuario...",
    "tab_per_tappa": "Por etapa",
    "tab_matrice": "Presencia de corredores",
    "matrix_select_riders": "Elige corredores a seguir (máx. 5)",
    "no_picks_riepilogo": "No se encontraron picks",
    "no_picks_riepilogo_sub": "Aún no has enviado picks en esta carrera.",
    "scout_avg_pct": "~{{pct}}% promedio",
    "scout_no_identical": "Nadie más tiene la misma alineación que tú",
    "scout_identical_count_one": "1 jugador tiene la misma alineación que tú",
    "scout_identical_count_many": "{{count}} jugadores tienen la misma alineación que tú",
    "scout_identical_count_other": "{{count}} jugadores tienen la misma alineación que tú",
    "scout_share_dialog": "Scouting Report — {{name}}",
    "share_hidden": "+ {{count}} JUGADORES MÁS · ABRE LA APP",
    "no_picks_tabella": "No se han enviado alineaciones",
    "no_picks_tabella_sub": "Los picks de otros jugadores aparecerán aquí.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "ELIGE",
    "race_tag_live": "EN VIVO",
    "race_tag_done": "FINALIZADA",
    "race_switcher_label": "Carreras",
    "race_history": "Historial de carreras",
    "race_group_next": "Próximas",
    "race_group_past": "Pasadas",
    "close": "Cerrar",
    "prev_stage": "Etapa anterior",
    "next_stage": "Etapa siguiente",
    "stage_list_title": "Etapas",
    "matrix_chosen_by": "{{name}} · elegido por {{count}} de {{total}}",
    "matrix_clear": "Quitar selección",
    "matrix_chosen_by_a11y": "elegido por {{count}} de {{total}} jugadores",
    "matrix_open_player": "Abrir las elecciones de {{name}}",
    "sheet_chosen_by": "{{count}} de {{total}}",
    "sheet_shared": "Igual que tú",
    "sheet_unique": "Elección única",
    "share_label": "LAS ELECCIONES",
    "share_most_picked": "MÁS ELEGIDO",
    "share_unique_picks": "ELECCIONES ÚNICAS",
    "share_unique_sub": "corredores elegidos por uno solo",
    "scout2_title": "Scout",
    "scout2_originality": "TU ORIGINALIDAD",
    "scout2_twin": "TU GEMELO",
    "scout2_identical": "ELECCIONES IDÉNTICAS",
    "scout2_identical_sub": "jugadores con la misma selección",
    "scout2_bold": "Atrevido",
    "scout2_balanced": "Equilibrado",
    "scout2_aligned": "Alineado",
    "scout2_in_common": "{{count}} de {{total}} en común",
    "scout2_none": "Ninguno",
    "scout2_popularity": "Popularidad de los corredores",
    "scout2_tap_hint": "Toca un corredor para resaltarlo en la tabla",
    "scout2_your_picks": "Tus elecciones",
    "scout2_also_by": "También lo eligió {{names}}",
    "scout2_only_you": "Solo tú",
    "scout2_outsiders": "Outsiders",
    "finished_banner": "Carrera terminada · eres {{pos}}º con {{pts}} pts",
    "finished_banner_nopos": "Carrera terminada",
    "finished_cta": "Clasificación",
    "scout2_like_you": "Quién jugó como tú",
    "scout2_twins_card": "TUS GEMELOS",
    "scout2_same_as_you": "{{count}} con tu misma selección",
    "scout2_same_picks": "Misma selección",
    "scout2_group_count": "{{count}} jugadores",
    "scout2_no_common": "Ningún corredor en común con",
    "scout2_other_identical": "Otras selecciones idénticas",
    "result_title": "Cómo fue",
    "result_total": "Has sumado {{pts}} pts",
    "result_pick_line": "previsto {{slot}}º · llegó {{rank}}º",
    "result_dnf": "no clasificado",
    "result_best": "Tu mejor",
    "result_worst": "Lo que más te costó",
    "result_malus": "Ganador no elegido",
    "result_bonus_top10": "Todos en el top 10",
    "result_bonus_top15": "Todos en el top 15",
    "result_winner": "El ganador",
    "result_winner_owners": "elegido por {{count}} de {{total}}",
    "result_nobody": "Nadie lo tenía",
    "result_difference": "Marcó la diferencia",
    "result_difference_sub": "quienes lo tenían sumaron {{delta}} pts de media frente al resto",
    "result_flop": "Hundió a muchos",
    "result_flop_sub": "quienes lo tenían sumaron {{delta}} pts de media frente al resto",
    "rules_title": "Reglas en breve",
    "rules_1": "Un corredor por etapa, tres en las contrarreloj.",
    "rules_2": "Un corredor no se puede usar dos veces en la misma carrera.",
    "rules_3": "Si te saltas aunque sea una etapa quedas fuera de la carrera: puedes seguirla, pero no jugar.",
    "rules_flip": "Flip: una sola vez por carrera, indicas un corredor de reserva; cuenta en lugar del titular solo si llega mejor.",
    "profile_flat": "Llana",
    "profile_hilly": "Ondulada",
    "profile_mountain": "Montaña",
    "profile_itt": "Contrarreloj",
    "profile_ttt": "Contrarreloj por equipos",
    "view_by_rider": "Por corredor",
    "view_by_player": "Por jugador",
    "tour_summary": "{{riders}} corredores elegidos por {{players}} jugadores",
    "your_pick": "Tu elección",
    "tour_your_result": "Tu resultado",
    "tour_stage_winner": "Ganador de la etapa",
    "stage_finished_banner": "Etapa terminada · eres {{pos}}º en la etapa ({{gap}})",
    "share_label_stage": "LAS ELECCIONES DE LA ETAPA",
    "share_distinct_riders": "CORREDORES DISTINTOS",
    "scout_t_position": "ESTÁS EN",
    "scout_t_break": "LA FUGA",
    "scout_t_small": "UN GRUPETTO",
    "scout_t_group": "EL PELOTÓN",
    "scout_t_with": "con {{count}} jugadores",
    "scout_t_alone": "solo tú",
    "scout_t_leader": "EL LÍDER ELIGIÓ",
    "scout_t_jerseys": "Los maillots: qué eligieron",
    "scout_t_breakaway": "En la fuga",
    "closes_at": "Cierra {{when}}",
    "closes_in": "Cierra en {{time}}",
    "profile_title": "Perfil altimétrico",
    "profile_climbs": "Subidas",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Perfil altimétrico: {{km}} km, altitud máxima {{max}} m, {{n}} subidas principales",
    "profile_sprint": "S = sprint intermedio",
    "profile_tap_climb": "Toca un puerto para ver el detalle",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Base",
    "climb_summit": "Cima",
    "climb_avg": "Pendiente media",
    "climb_length": "Longitud",
    "profile_bonus": "B = meta de bonificación"
  },
  "join": {
    "back_home": "Volver al inicio",
    "welcome": "¡Bienvenido a la liga!",
    "already_member": "Ya eres miembro de esta liga.",
    "error": "No se puede unir a la liga.",
    "joining": "Uniéndose a la liga...",
    "success": "¡Acceso completado!"
  },
  "leaderboard": {
    "stage_cancelled": "Etapa {{n}} anulada: no cuenta para la clasificación",
    "loading": "Cargando...",
    "no_result_title": "Sin resultados",
    "no_result_sub": "Los resultados de esta carrera aún no están disponibles.",
    "gc_rank": "Clasificación General",
    "team_no_data": "No hay datos de equipo para esta etapa.",
    "team_title": "CLASIFICACIÓN POR EQUIPOS",
    "stage": "Etapa {{n}}",
    "general": "General",
    "stage_rank": "Clasificación Etapa {{n}}",
    "no_data_title": "Datos no disponibles",
    "no_data_sub": "La clasificación de esta etapa aún no se ha calculado.",
    "one_day_race": "One Day Race",
    "title": "Clasificación",
    "no_data": "No hay datos disponibles.",
    "share": "Compartir",
    "jersey_tempo": "Tiempo",
    "jersey_punti": "Puntos",
    "jersey_gpm": "Montaña",
    "tab_individual": "Individual",
    "tab_team": "Equipos",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "EN CURSO",
    "race_tag_done": "FINALIZADA",
    "race_tag_soon": "PRÓXIMA",
    "leader_label": "De líder",
    "lead_over_second": "{{gap}} sobre el 2º",
    "winner": "Ganador",
    "sheet_total": "Total",
    "tie": "empate",
    "top10_count": "{{count}} en el top 10",
    "has_winner": "Tiene al ganador",
    "my_rank": "Tu posición",
    "counts_for_team": "Cuenta para el equipo",
    "not_counting": "No cuenta",
    "share_label": "CLASIFICACIÓN",
    "gap_above": "{{gap}} del {{pos}}º",
    "gap_below": "{{gap}} sobre el {{pos}}º",
    "trend_up": "Sube {{n}} puestos",
    "trend_down": "Baja {{n}} puestos",
    "trend_same": "Posición sin cambios",
    "sheet_by_stage": "Etapa por etapa"
  },
  "leagues": {
    "albo": "Palmarés",
    "no_podio": "aún no ha conseguido podios.",
    "victories": "Victorias",
    "second": "2º puesto",
    "third": "3er puesto",
    "races_count_one": "1 carrera",
    "races_count_many": "{{count}} carreras",
    "races_count_other": "{{count}} carreras",
    "player_a": "-- Jugador A --",
    "player_b": "-- Jugador B --",
    "draws_one": "1 empate",
    "draws_many": "{{count}} empates",
    "draws_other": "{{count}} empates",
    "on_races_one": "en 1 carrera",
    "on_races_many": "en {{count}} carreras",
    "on_races_other": "en {{count}} carreras",
    "no_common": "No hay carreras en común con resultados.",
    "settings": "AJUSTES",
    "your_position": "Tu posición",
    "stagionale": "Clasificación de Temporada",
    "hide": "OCULTAR",
    "show_all_one": "MOSTRAR TODOS (1 más)",
    "show_all_many": "MOSTRAR TODOS ({{count}} más)",
    "show_all_other": "MOSTRAR TODOS ({{count}} más)",
    "no_data": "Aún no hay datos disponibles.",
    "head2head": "Head to Head",
    "races_count": "{{count}} carreras",
    "draws": "{{count}} empates",
    "on_races": "en {{count}} carreras",
    "show_all": "MOSTRAR TODOS ({{count}} más)",
    "badge_empty_1": "Ningún badge aún — ¡la gloria te espera! 🚴",
    "badge_empty_2": "Cero logros por ahora, pero cada carrera es una oportunidad. 💪",
    "badge_empty_3": "Aún sin badges — los grandes campeones empiezan desde cero. 🏅",
    "badge_empty_4": "El primer badge siempre es el más difícil. ¡Casi! ⚡",
    "gap_to_podium": "{{gap}} pts del podio",
    "gap_to_prev": "{{gap}} pts del {{pos}}º",
    "lead_over_next": "+{{gap}} pts sobre el {{pos}}º",
    "invite_title": "¿Jugando solo?",
    "invite_body": "Invita a tus amigos para jugar juntos en esta liga.",
    "invite_cta": "Invitar amigos",
    "pick_member": "Elige un jugador",
    "position_a11y": "Posición {{pos}}",
    "load_error": "No se pudo cargar la liga.",
    "tab_standings": "Clasificación",
    "tab_stats": "Estadísticas",
    "tab_rivalry": "Desafíos"
  },
  "league": {
    "member_count_one": "1 usuario en esta liga",
    "member_count_many": "{{count}} usuarios en esta liga",
    "member_count_other": "{{count}} usuarios en esta liga",
    "index_join": "Unirse",
    "index_create": "Crear liga",
    "manage_title": "Gestionar {{name}}",
    "err_name": "Introduce un nombre",
    "err_password": "Introduce una contraseña",
    "err_creation": "Error al crear la liga",
    "create_title": "Crear nueva liga",
    "create": "Crear liga",
    "privacy": "Privacidad",
    "public": "Pública",
    "private": "Privada",
    "err_join": "Error o ya eres miembro",
    "join_title": "Unirse a una liga",
    "search_placeholder": "Buscar por nombre...",
    "search": "Buscar",
    "no_leagues_found": "No se encontraron ligas",
    "join_btn": "Entrar",
    "password_insert": "Introduce la contraseña:",
    "calendar_section": "Calendario",
    "calendar_desc_admin": "Gestionar carreras de la liga",
    "calendar_desc_user": "Carreras en el calendario",
    "manage": "Gestionar",
    "view": "Ver",
    "calendar_title": "Calendario de liga",
    "calendar_save_one": "Guardar calendario (1 carrera)",
    "calendar_save_many": "Guardar calendario ({{count}} carreras)",
    "calendar_save_other": "Guardar calendario ({{count}} carreras)",
    "races_selected_one": "1 carrera seleccionada",
    "races_selected_many": "{{count}} carreras seleccionadas",
    "races_selected_other": "{{count}} carreras seleccionadas",
    "deselect_all": "Deseleccionar todo",
    "select_all": "Seleccionar todo",
    "loading": "Cargando...",
    "settings_section": "Ajustes de liga",
    "settings_name": "Nombre de la liga",
    "settings_save": "Guardar",
    "settings_autopick": "Autopick",
    "settings_autopick_desc": "Si un usuario no hace el pick, el sistema elige automáticamente al mejor ciclista disponible de la etapa anterior.",
    "settings_team_race": "Carrera por equipos",
    "settings_team_race_desc": "Activar el modo equipo para esta liga.",
    "settings_team_size": "Máx. miembros por equipo",
    "settings_scoring": "Puntuación",
    "settings_scoring_best2": "Mejores 2 — suma de los dos primeros",
    "settings_scoring_avg": "Media de todos los miembros",
    "settings_flip": "Flip",
    "settings_flip_desc": "Cada usuario puede designar un corredor comodín para una etapa a elección. Al calcular puntos se elige automáticamente el mejor resultado entre el titular y el flip. Usable una vez por carrera.",
    "invite_section": "Enlace de invitación",
    "invite_loading": "Cargando...",
    "invite_copied": "¡Copiado!",
    "invite_copy": "Copiar",
    "invite_share_btn": "Compartir",
    "members_section": "Miembros",
    "members_title_admin": "Gestionar miembros",
    "members_title_user": "Miembros de la liga",
    "leaving": "Saliendo...",
    "leave": "Abandonar esta liga",
    "admin_badge": "Admin",
    "remove": "Eliminar",
    "pick_admin_title": "Corrección de Picks",
    "pick_admin_desc": "Editar los picks de los usuarios",
    "pick_admin_open": "Abrir",
    "pick_admin_save": "Guardar Picks",
    "pick_admin_none": "— ninguno —",
    "pick_admin_search": "Buscar corredor o dorsal",
    "pick_admin_retired": "retirado",
    "pick_admin_saved2": "{{set}} picks guardadas, {{removed}} eliminadas",
    "pick_admin_nochange": "No hay cambios que guardar",
    "pick_admin_undo": "Deshacer la última corrección",
    "pick_admin_undone": "Corrección deshecha",
    "pick_admin_future": "También se eliminaron {{n}} picks de etapas futuras con el mismo corredor",
    "pick_admin_notify": "Avisar a los jugadores",
    "pick_admin_no_calendar": "Esta carrera no está en el calendario de la liga: no se puede guardar",
    "stats_section": "Estadísticas",
    "stats_participation": "Participación por etapa",
    "stats_title": "Estadísticas de participación",
    "stats_no_data": "No hay datos disponibles.",
    "stats_error": "No se pudieron cargar las estadísticas. Inténtalo de nuevo.",
    "team_loading": "Cargando equipos...",
    "team_section": "Equipo",
    "team_cancel": "Cancelar",
    "team_create_btn": "+ Crear equipo",
    "team_locked": "Carrera en curso — cambios de equipo desactivados",
    "team_create": "Crear equipo",
    "team_members_count_one": "1/{{max}} miembro",
    "team_members_count_many": "{{count}}/{{max}} miembros",
    "team_members_count_other": "{{count}}/{{max}} miembros",
    "team_invite_btn": "+ Invitar",
    "team_leave": "Salir",
    "team_save": "Guardar",
    "team_pwd_hint": "Dejar vacío para hacer público",
    "team_pending": "Esperando respuesta",
    "team_invite_cancel": "Cancelar",
    "team_invite_section": "Invitar a un miembro",
    "team_no_invitable": "No hay miembros disponibles para invitar.",
    "team_invite_action": "Invitar",
    "team_private_label": "\"{{name}}\" es privado:",
    "team_join_action": "Entrar",
    "team_empty": "Aún no hay equipos — ¡sé el primero en crear uno!",
    "team_mine": "EL TUYO",
    "team_join": "Unirse",
    "team_full": "Completo",
    "team_members": "Miembros",
    "join": "Unirse",
    "calendar_save": "Guardar calendario ({{count}} carreras)",
    "invite_share": "Compartir",
    "races_selected": "{{count}} carreras seleccionadas",
    "invite_desc": "Comparte este enlace — quien haga clic entra directamente a la liga.",
    "invite_desc_pwd": "Comparte este enlace — quien haga clic entra directamente a la liga con la contraseña incluida.",
    "member_count": "{{count}} usuarios en esta liga",
    "team_members_count": "{{count}}/{{max}} miembros",
    "create_name_placeholder": "Ej.: Los Aficionados del Pedal",
    "create_password_placeholder": "Contraseña de acceso",
    "calendar_saved": "¡Calendario guardado!",
    "err_name_empty": "El nombre no puede estar vacío",
    "settings_saved": "¡Ajustes guardados!",
    "pwd_public_placeholder": "Dejar vacío para liga pública",
    "invite_share_title": "Únete a {{name}} en Virtua Cycling",
    "invite_share_message": "Únete a la liga \"{{name}}\" en Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "¿Regenerar el enlace? Todos los enlaces anteriores dejarán de funcionar.",
    "invite_regenerating": "Regenerando...",
    "invite_regen_btn": "Regenerar enlace (revocar anteriores)",
    "confirm_remove": "¿Eliminar a {{name}} de la liga?",
    "member_removed": "{{name}} eliminado",
    "confirm_demote": "¿Retirar privilegios de admin a {{name}}?",
    "confirm_promote": "¿Ascender a {{name}} como admin?",
    "demote_admin": "Retirar Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "¡{{count}} picks guardados!",
    "confirm_team_leave": "¿Abandonar el equipo?",
    "confirm_kick": "¿Eliminar a {{name}} del equipo?",
    "team_invite_sent": "¡Invitación enviada!",
    "team_pwd_saved": "¡Contraseña actualizada!",
    "team_name_placeholder": "Nombre del equipo...",
    "team_rename_placeholder": "Nuevo nombre...",
    "team_newpwd_placeholder": "Nueva contraseña..."
  },
  "profile": {
    "nick_title": "Nickname",
    "theme_title": "Personalización del Tema",
    "theme_dark": "Oscuro",
    "theme_light": "Claro",
    "lang": "Idioma",
    "save_lang": "Guardar idioma",
    "nick_success": "¡Nickname actualizado!",
    "nick": "Nickname",
    "nick_placeholder": "Introduce nickname",
    "update_btn": "Actualizar",
    "pass": "Contraseña",
    "show_pass": "Mostrar contraseña",
    "update_pass": "Actualizar contraseña",
    "avatars_title": "Avatares",
    "avatars": "Mostrar avatares",
    "avatars_sub": "Desactívalo si tu teléfono va lento: en lugar de los avatares verás el maillot de los ciclistas y el nombre de los jugadores. Tu avatar en Inicio se mantiene.",
    "notif_title": "Notificaciones Push",
    "my_leagues": "Mis ligas",
    "members_count_one": "1 miembro",
    "members_count_many": "{{count}} miembros",
    "members_count_other": "{{count}} miembros",
    "default_badge": "DEFAULT",
    "set_default": "Default ",
    "leave": "Abandonar",
    "settings": "Ajustes de Perfil",
    "hi": "Hola",
    "intro": "aquí puedes gestionar tu cuenta.",
    "admin_panel": "Panel Admin",
    "theme_sub": "Sincronizado en todos tus dispositivos.",
    "lang_title": "Lingua / Language",
    "security_title": "Seguridad",
    "security_success": "¡Datos actualizados!",
    "notif_enabled": "Activar notificaciones",
    "notif_enabled_sub": "Activar o desactivar todas las notificaciones",
    "notif_results": "Resultados de carrera",
    "notif_results_sub": "Notificar cuando se publiquen los resultados",
    "notif_startlist": "Lista de salida",
    "notif_startlist_sub": "Notificar cuando la lista de salida esté disponible",
    "notif_reminder": "Recordatorio de pick",
    "notif_reminder_sub": "Recibe un recordatorio antes del cierre de los picks",
    "notif_reminder_off": "Sin recordatorio",
    "notif_reminder_no_pick": "Solo si aún no he elegido",
    "notif_reminder_always": "Siempre",
    "notif_saving": "Guardando...",
    "notif_saved": "¡Preferencias guardadas!",
    "notif_error": "Error al guardar",
    "nick_taken": "Nickname ya en uso",
    "pass_min_length": "La contraseña debe tener al menos 6 caracteres",
    "pass_mismatch": "Las contraseñas no coinciden",
    "new_pass_placeholder": "Nueva contraseña",
    "league_default_updated": "¡Liga predeterminada actualizada!",
    "league_leave_confirm": "¿Seguro que quieres abandonar \"{{name}}\"?",
    "league_left": "Liga abandonada.",
    "confirm_password": "Confirmar contraseña",
    "avatar_title": "Tu avatar",
    "avatar_jersey": "Maillot",
    "avatar_cap": "Gorra",
    "avatar_glasses": "Gafas",
    "avatar_cyclist": "Ciclista",
    "avatar_patch": "Parche del maillot",
    "avatar_saved": "¡Avatar guardado!",
    "avatar_save_btn": "Guardar avatar",
    "rules": "Reglamento",
    "report_bug": "Reportar un problema",
    "bug_sent": "Reporte enviado, ¡gracias!",
    "bug_placeholder": "Describe el problema...",
    "group_identity": "Identidad",
    "group_account": "Cuenta",
    "group_contact": "Contáctanos",
    "group_danger": "Zona peligrosa",
    "change_pass": "Cambiar",
    "cancel": "Cancelar",
    "show_more": "Mostrar todas ({{count}} más)",
    "show_less": "Mostrar menos",
    "delete_confirm": "¿Seguro que quieres eliminar tu cuenta? Esta acción es irreversible y todos tus datos se eliminarán definitivamente.",
    "delete_desc": "La eliminación es permanente y borra todos tus datos, elecciones, ligas y preferencias.",
    "delete_btn": "Eliminar mi cuenta",
    "delete_league_owner": "Creaste una liga con otros miembros: al eliminar tu cuenta desaparecería para todos. Contáctanos para transferirla o elimínala antes.",
    "replay_tour": "Ver el tour de nuevo",
    "leave_feedback": "Dejar un comentario",
    "feedback_placeholder": "Una idea, una sugerencia o un comentario: nos encantará leerte...",
    "feedback_sent": "¡Gracias por tu comentario! 🙏",
    "rate_app": "Valorar Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Introduce un nickname",
    "err_nickname_taken": "Nickname ya en uso",
    "register_ok": "¡Registro completado! Revisa tu email y confirma tu cuenta antes de iniciar sesión.",
    "err_email": "Introduce tu email",
    "forgot_sent": "¡Email enviado! Revisa tu bandeja de entrada.",
    "tagline": "Toma tu lugar en el coche de equipo.",
    "tab_login": "Iniciar sesión",
    "tab_register": "Registrarse",
    "forgot_hint": "Introduce tu email y te enviamos un enlace para restablecer la contraseña.",
    "email": "Email",
    "forgot_send": "Enviar enlace",
    "back": "← Volver al inicio de sesión",
    "nickname": "Nickname",
    "password": "Contraseña",
    "btn_login": "INICIAR SESIÓN",
    "btn_register": "REGISTRARSE",
    "forgot_pass": "¿Olvidaste la contraseña?",
    "or": "o",
    "google_login": "Iniciar sesión con Google",
    "google_register": "Registrarse con Google",
    "privacy_text": "Al continuar aceptas nuestra",
    "privacy_link": "Política de Privacidad",
    "loading": "…"
  },
  "news": {
    "title": "NOTICIAS",
    "loading": "Cargando...",
    "no_news": "No hay noticias disponibles.",
    "pinned": "Destacado",
    "not_found": "Artículo no encontrado.",
    "open_external": "Abrir el artículo en {{source}}",
    "disclaimer": "Titulares y enlaces proceden de fuentes externas: los artículos pertenecen a sus editores.",
    "tab_unread_one": "{{count}} noticia nueva",
    "tab_unread_other": "{{count}} noticias nuevas",
    "load_error": "No hemos podido cargar las noticias."
  },
  "reset_password": {
    "title": "NUEVA CONTRASEÑA",
    "subtitle": "Elige una nueva contraseña para tu cuenta",
    "show_pass": "Mostrar contraseña",
    "loading": "Verificando enlace...",
    "success": "¡Contraseña actualizada! Redirigiendo..."
  },
  "confirm": {
    "verifying": "Verificando...",
    "error": "Error durante la confirmación.",
    "success": "¡Email confirmado! Redirigiendo...",
    "missing_params": "Parámetros faltantes en el enlace.",
    "missing_params_detail": "Asegúrate de haber hecho clic en el enlace correcto de tu email.",
    "critical_error": "Error crítico de conexión."
  },
  "notifications": {
    "title": "Notificaciones",
    "empty": "Aún no hay notificaciones",
    "accept": "Aceptar",
    "refuse": "Rechazar",
    "now": "Ahora",
    "minutes_ago": "Hace {{count}} min",
    "hours_ago": "Hace {{count}}h"
  },
  "quiz": {
    "card_sub": "10 preguntas sobre el Tour de Francia — ¿cuánto sabes?",
    "loading": "Cargando preguntas...",
    "no_questions": "No hay preguntas disponibles",
    "question_count": "Pregunta {{current}} de {{total}}",
    "easy": "Fácil",
    "medium": "Medio",
    "hard": "Difícil",
    "correct": "¡Respuesta correcta!",
    "wrong": "Incorrecto. La respuesta era: {{answer}}",
    "next": "Siguiente",
    "see_result": "Ver resultado",
    "restart": "Jugar de nuevo",
    "result_excellent": "¡Eres un verdadero experto en ciclismo!",
    "result_good": "¡Gran conocimiento del Tour de Francia!",
    "result_average": "Conocimiento discreto. ¡Mira más carreras!",
    "result_poor": "Hay margen de mejora — ¡pero para eso se pedalea!"
  },
  "person": {
    "hint": "Elige el aspecto de tu avatar: lo verás en la pantalla de inicio.",
    "gender": "Género",
    "man": "Hombre",
    "woman": "Mujer",
    "hair_short": "Corto",
    "hair_curly": "Rizado",
    "hair_wavy": "Ondulado",
    "hair_shaved": "Rapado",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Tocado",
    "wear_none": "Ninguno",
    "wear_cap": "Gorra",
    "wear_helmet": "Casco",
    "glasses": "Gafas",
    "glasses_off": "No",
    "glasses_on": "Sí",
    "jersey": "Maillot",
    "jersey_vertical": "Vertical",
    "jersey_horizontal": "Horizontal",
    "jersey_classic": "Clásico",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Lunares",
    "row_skin": "Piel",
    "row_hair": "Pelo",
    "row_brow": "Cejas",
    "row_iris": "Ojos",
    "row_wear": "Tocado",
    "row_visor": "Visera",
    "row_vents": "Ventilaciones",
    "row_frame": "Montura de gafas",
    "save": "GUARDAR",
    "saved": "Avatar guardado",
    "save_error": "Error al guardar",
    "reset": "Restablecer",
    "reset_done": "Restablecido",
    "tab_face": "Rostro",
    "tab_hair": "Pelo",
    "tab_gear": "Accesorios",
    "tab_jersey": "Maillot",
    "row_lens": "Lentes",
    "jersey_body": "Cuerpo",
    "jersey_sleeves": "Mangas",
    "jersey_band": "Banda",
    "jersey_trim": "Cuello y puños",
    "view_mine": "Mi avatar",
    "view_world_champion": "Maillot arcoíris",
    "world_champion_since": "Campeón del mundo en {{league}} desde el {{date}}",
    "view_european_champion": "Maillot europeo",
    "european_champion_since": "Campeón de Europa en {{league}} desde el {{date}}",
    "view_worldcup_leader": "Maillot de la Copa del Mundo",
    "worldcup_leader_since": "Líder de la clasificación de {{league}} desde el {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Editar avatar",
    "avatar_cut": "Corte",
    "avatar_hair": "Pelo",
    "avatar_skin": "Piel",
    "avatar_beard": "Barba",
    "avatar_beard_none": "Ninguna",
    "avatar_face": "Cara",
    "avatar_face_none": "Estándar",
    "avatar_face_a": "Delgado",
    "avatar_face_b": "Robusto",
    "avatar_face_c": "Joven",
    "avatar_face_d": "Anguloso",
    "avatar_face_e": "Maduro",
    "avatar_face_f": "Sonriente",
    "avatar_face_g": "Sonrisa cerrada",
    "avatar_brow": "Cejas",
    "avatar_brow_0": "Normales",
    "avatar_brow_1": "Finas",
    "avatar_brow_2": "Pobladas",
    "avatar_beard_light": "Ligera",
    "avatar_hex": "Otro color (#RRGGBB)",
    "avatar_save": "Guardar",
    "avatar_reset": "Restablecer",
    "avatar_undo": "Deshacer último cambio",
    "avatar_saved": "Guardado",
    "avatar_bad_hex": "Color no válido: usa #RRGGBB",
    "avatar_err": "Error al guardar",
    "avatar_beard_legend": "1 sombra · 2 bigote · 3 corta · 4 completa · 6 bigote+perilla · 7 circular · 8 sombra ligera",
    "hair_wavy_medium": "Ondulado medio",
    "hair_receding": "Entradas",
    "hair_messy": "Despeinado",
    "hair_buzz": "Muy corto",
    "hair_curly_short": "Rizos cortos",
    "hair_medium": "Media melena",
    "hair_flip_off": "Lado normal",
    "hair_flip_on": "Invertido",
    "hair_side_part": "Raya al lado",
    "hair_slicked_back": "Hacia atrás",
    "hair_forward": "Hacia delante",
    "hair_high_line": "Entradas altas",
    "hair_wavy_short": "Ondulado corto",
    "hair_curly_medium": "Rizo medio",
    "hair_receding_short": "Entradas cortas",
    "beard_stubble_light": "Sombra ligera",
    "hair_long": "Largo",
    "hair_ponytail": "Coleta",
    "hair_bun": "Moño",
    "hair_long_wavy": "Ondulado",
    "hair_braid": "Trenza",
    "beard": "Barba",
    "beard_none": "Ninguna",
    "beard_stubble": "Sombra",
    "beard_moustache": "Bigote",
    "beard_short": "Corta",
    "beard_full": "Completa",
    "beard_goatee": "Bigote y perilla",
    "beard_circle": "Circular",
    "beard_op_normal": "Normal",
    "beard_op_light": "Ligera",
    "fringe": "Flequillo",
    "fringe_off": "Sin",
    "fringe_on": "Con flequillo"
  },
  "app_update": {
    "title": "Nueva versión lista",
    "body": "Reinicia la app para usar las novedades.",
    "restart": "Reiniciar",
    "later": "Más tarde"
  },
  "avatar": {
    "invite_title": "¡Aquí tienes tu avatar!",
    "invite_body": "Hemos creado uno para ti: personalízalo como quieras.",
    "invite_cta": "Personalizar",
    "invite_dismiss": "Cerrar",
    "edit_a11y": "Personaliza tu avatar"
  },
  "jersey_celebration": {
    "ok": "¡Genial!"
  },
  "insight": {
    "you": "Contigo",
    "form": "Forma",
    "never": "Nunca lo has elegido: sería la primera vez.",
    "picked": "Veces elegido",
    "avg_rank": "Puesto medio",
    "avg_gap": "Diferencia media",
    "best": "Mejor resultado",
    "dnf": "Abandonos contigo",
    "last": "Última vez",
    "retired": "abandonó",
    "form_avg": "Media de las últimas 5",
    "season_races": "Carreras esta temporada",
    "top10": "Top 10",
    "wins": "Victorias",
    "dnfs": "Abandonos",
    "cat_1": "Etapas llanas",
    "cat_2": "Etapas de montaña",
    "cat_3": "Etapas onduladas",
    "last5": "Últimos 5 resultados",
    "no_results": "Aún sin resultados esta temporada.",
    "open_a11y": "Estadísticas de {{name}}",
    "summary": "{{n}}× contigo · media {{rank}}°",
    "summary_never": "Nunca elegido por ti",
    "open": "Insights"
  },
  "badges": {
    "title": "Insignias",
    "album_title": "Vitrina de trofeos",
    "earned_of": "{{earned}} de {{total}} insignias",
    "open_album": "Abrir la vitrina de trofeos",
    "recent": "Últimas conseguidas",
    "next_goals": "Metas cercanas",
    "filter_all": "Todas",
    "filter_earned": "Conseguidas",
    "filter_todo": "Por conseguir",
    "group_gt": "Grandes Vueltas",
    "group_monuments": "Monumentos y clásicas",
    "group_picks": "Habilidad en las elecciones",
    "group_consistency": "Constancia",
    "group_league": "Clasificación de liga",
    "group_social": "Sociales",
    "group_meta": "Colección",
    "tier_1": "Bronce",
    "tier_2": "Plata",
    "tier_3": "Oro",
    "tier_4": "Platino",
    "tier_special": "Hito",
    "secret_title": "Insignia secreta",
    "secret_hint": "Descúbrela jugando.",
    "earned_on": "Conseguida el {{date}}",
    "progress": "{{value}} de {{threshold}}",
    "rarity": "La tiene el {{pct}}% de la liga ({{n}} de {{m}})",
    "rarity_none": "Nadie la tiene todavía: puedes ser el primero.",
    "seasons": "Temporadas conseguidas: {{count}}",
    "complete": "Completada",
    "locked": "Por conseguir",
    "player": "Jugador",
    "none_me": "Aún sin insignias: la próxima carrera es tu oportunidad.",
    "none_other": "{{name}} aún no tiene insignias.",
    "empty_filter": "Nada que mostrar con este filtro.",
    "load_error": "No se pudieron cargar las insignias.",
    "not_enabled": "Las insignias aún no están activas en esta liga.",
    "fam": {
      "RE_GT": {
        "title": "Rey de las Grandes Vueltas",
        "desc": "Grandes Vueltas ganadas: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Rey del Giro",
        "desc": "Gana la general del Giro de Italia"
      },
      "WIN_TOUR": {
        "title": "Rey del Tour",
        "desc": "Gana la general del Tour de Francia"
      },
      "WIN_VUELTA": {
        "title": "Rey de la Vuelta",
        "desc": "Gana la general de la Vuelta"
      },
      "GT_PODI": {
        "title": "Podios en las Grandes Vueltas",
        "desc": "Podios en Grandes Vueltas: {{n}}"
      },
      "GT_DAYS": {
        "title": "Días de líder",
        "desc": "Días como líder de la general: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Maglia rosa",
        "desc": "Conviértete en líder de la general del Giro de Italia"
      },
      "FIRST_YELLOW": {
        "title": "Maillot amarillo",
        "desc": "Conviértete en líder de la general del Tour de Francia"
      },
      "FIRST_RED": {
        "title": "Maillot rojo",
        "desc": "Conviértete en líder de la general de la Vuelta"
      },
      "GT_GREEN": {
        "title": "Rey de los velocistas",
        "desc": "Clasificaciones por puntos ganadas en Grandes Vueltas: {{n}}"
      },
      "GT_POIS": {
        "title": "Rey de la montaña",
        "desc": "Clasificaciones de la montaña ganadas en Grandes Vueltas: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Cazador de etapas",
        "desc": "Etapas ganadas en Grandes Vueltas: {{n}}"
      },
      "GT_WIRE": {
        "title": "De principio a fin",
        "desc": "Lidera la general de la primera a la última etapa y gana la Gran Vuelta"
      },
      "GT_COMEBACK": {
        "title": "Remontada",
        "desc": "Gana una Gran Vuelta estando fuera del top 10 tras la primera semana"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Triunfo total",
        "desc": "Gana general, puntos y montaña en la misma Gran Vuelta"
      },
      "GT_HEARTBREAK": {
        "title": "El golpe duro",
        "desc": "Eras líder en la víspera de la última etapa, pero no ganaste la Gran Vuelta"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Corona",
        "desc": "Gana Giro, Tour y Vuelta"
      },
      "THE_DOUBLE": {
        "title": "El Doblete",
        "desc": "Gana Giro y Tour el mismo año"
      },
      "RE_MONUMENTI": {
        "title": "Rey de los Monumentos",
        "desc": "Monumentos ganados: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Gana la Milán-San Remo"
      },
      "WIN_FIANDRE": {
        "title": "El Tour de Flandes",
        "desc": "Gana el Tour de Flandes"
      },
      "WIN_ROUBAIX": {
        "title": "El Infierno del Norte",
        "desc": "Gana la París-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Decana",
        "desc": "Gana la Lieja-Bastoña-Lieja"
      },
      "WIN_LOMBARDIA": {
        "title": "La clásica de las hojas muertas",
        "desc": "Gana el Giro de Lombardía"
      },
      "MONUMENTS_SWEEP": {
        "title": "Pleno de Monumentos",
        "desc": "Gana los 5 Monumentos"
      },
      "RE_DEL_NORD": {
        "title": "Rey del Norte",
        "desc": "Gana Flandes y Roubaix el mismo año"
      },
      "ARDENNES": {
        "title": "Triplete de las Ardenas",
        "desc": "Gana Amstel, Flecha Valona y Lieja el mismo año"
      },
      "DUE_MARI": {
        "title": "Carrera de los dos mares",
        "desc": "Gana París-Niza y Tirreno-Adriático el mismo año"
      },
      "MODALITA_POGACAR": {
        "title": "Modo Pogačar",
        "desc": "Gana las 3 Grandes Vueltas y los 5 Monumentos"
      },
      "RE_CLASSICHE": {
        "title": "Rey de las Clásicas",
        "desc": "Clásicas ganadas: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Rey de las vueltas por etapas",
        "desc": "Vueltas por etapas ganadas: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Campeón del Mundo",
        "desc": "Gana la prueba en línea de los Mundiales"
      },
      "EURO_CHAMP": {
        "title": "Campeón de Europa",
        "desc": "Gana la prueba en línea de los Europeos"
      },
      "CRONOMAN": {
        "title": "Contrarrelojista",
        "desc": "Gana una contrarreloj de los Mundiales o los Europeos"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Único de la liga en elegir al ganador: {{n}}"
      },
      "PROFETA": {
        "title": "Profeta",
        "desc": "Elecciones ganadoras: {{n}}"
      },
      "FIUTO": {
        "title": "Olfato",
        "desc": "Ganadores elegidos por pocos: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Ganador de carrera",
        "desc": "Carreras ganadas en la liga: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Habitual del podio",
        "desc": "Podios de carrera en la liga: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debut",
        "desc": "Juega tu primera carrera"
      },
      "PRESENZE": {
        "title": "Presencias",
        "desc": "Carreras jugadas: {{n}}"
      },
      "SERIE": {
        "title": "En racha",
        "desc": "Carreras seguidas jugadas: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Temporada perfecta",
        "desc": "Juega todas las carreras de la temporada"
      },
      "LEADER_STAGIONE": {
        "title": "Al mando",
        "desc": "Carreras cerradas al mando de la clasificación: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Campeón de liga",
        "desc": "Termina la temporada primero en la clasificación"
      },
      "PODIO_LEGA": {
        "title": "Podio de liga",
        "desc": "Termina la temporada en el podio de la clasificación"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Termina la temporada entre los 10 primeros de la clasificación"
      },
      "SCALATORE": {
        "title": "Escalador",
        "desc": "Posiciones ganadas en una sola carrera: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Matagigantes",
        "desc": "Carreras terminadas por delante del líder de la clasificación: {{n}}"
      },
      "ALBUM": {
        "title": "Álbum",
        "desc": "Insignias conseguidas: {{n}}"
      },
      "LEGGENDA": {
        "title": "Leyenda",
        "desc": "Consigue todas las insignias"
      }
    },
    "celebration_one": "¡Nueva insignia!",
    "celebration_many": "¡{{n}} nuevas insignias!",
    "celebration_more": "y {{n}} más",
    "share": "Compartir",
    "share_label": "INSIGNIA CONSEGUIDA",
    "share_dialog": "Mi insignia: {{name}}",
    "share_text": "¡He conseguido la insignia «{{name}}» en Virtua Cycling! {{site}}",
    "showcase_title": "Destacados",
    "showcase_hint": "Elige hasta 3 insignias para lucir. Si no eliges, mostramos las más raras que tengas.",
    "showcase_edit": "Editar",
    "showcase_auto": "Automático",
    "showcase_save": "Guardar",
    "showcase_count": "{{n}} de 3 elegidas",
    "showcase_err": "No se pudo guardar la selección.",
    "showcase_a11y": "Tus insignias destacadas",
    "showcase_none": "Consigue tu primera insignia para verla aquí.",
    "showcase_pick_empty": "Aún no tienes insignias para el escaparate.",
    "jerseys_title": "Maillots de las Grandes Vueltas",
    "jersey_pink": "Maglia rosa",
    "jersey_yellow": "Maillot amarillo",
    "jersey_red": "Maillot rojo",
    "days_caption": "Días con el maillot",
    "section_jerseys": "Maillots",
    "special_title": "Maillots especiales",
    "special_now": "En uso",
    "trophy_sub": "Insignias, maillots y palmarés"
  },
  "rivalry": {
    "title": "Desafíos",
    "intro": "Elige un rival. Si acepta, a partir de esa carrera gana el punto quien termine por delante del otro. Toda la liga ve cómo va.",
    "slots": "Desafíos lanzados: {{used}} de {{max}}",
    "limit_reached": "Has lanzado el máximo de desafíos. Cancela o cierra uno para lanzar otro.",
    "no_candidates": "No hay otros jugadores a quienes desafiar.",
    "challenge_cta": "Lanzar un desafío",
    "pick_title": "¿A quién quieres desafiar?",
    "confirm_challenge": "¿Desafiar a {{name}}? Recibirá la solicitud y podrá aceptar o rechazar.",
    "sent": "Solicitud enviada a {{name}}.",
    "accepted": "Has aceptado el desafío con {{name}}.",
    "incoming_title": "Solicitudes recibidas",
    "incoming_line": "{{name}} te desafía",
    "accept": "Aceptar",
    "decline": "Rechazar",
    "waiting_title": "Esperando respuesta",
    "waiting_line": "Esperando a {{name}}",
    "cancel": "Cancelar",
    "mine_title": "Tus desafíos",
    "league_title": "En la liga",
    "ended_title": "Desafíos terminados: {{count}}",
    "empty": "No hay desafíos en curso en la liga. ¡Lanza el primero!",
    "vs": "contra",
    "score_a11y": "{{a}} a {{b}}",
    "last_point": "Último punto: {{name}} en {{race}}",
    "no_races": "Aún sin carreras",
    "won_by": "Ganado por {{name}}",
    "drawn": "Terminó en empate",
    "detail_title": "Desafío",
    "results_title": "Carrera a carrera",
    "no_results": "Aún no se ha otorgado ningún punto.",
    "point_to": "Punto para {{name}}",
    "end_cta": "Cerrar el desafío",
    "end_confirm": "¿Cerrar el desafío con {{name}}?",
    "rematch": "Revancha",
    "load_error": "No se pudieron cargar los desafíos.",
    "err_limit": "Ya has lanzado el máximo de desafíos.",
    "err_exists": "Ya estáis en un desafío, o hay una solicitud en curso.",
    "err_invalid": "Esta solicitud ya no es válida.",
    "err_generic": "No se pudo completar la acción.",
    "notif_accepted": "Desafío aceptado",
    "notif_declined": "Desafío rechazado"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Competición"
  },
  "no_league": {
    "title": "No participas en ninguna liga {{comp}}",
    "body": "Puedes unirte a una liga o crear una nueva desde la sección Ligas.",
    "body_official": "Puedes entrar en la liga oficial cuando quieras, o unirte o crear una liga privada desde la sección Ligas.",
    "join": "Entrar en {{name}}",
    "go_leagues": "Ir a las ligas"
  }
}
